import {Navigate, Outlet} from 'react-router-dom'
import {useAuthStore} from '@/features/auth/store/useAuthStore'
import {ROUTE_LOGIN} from '@/utilities/constants'

export const PrivateRoute = () => {
    const accessToken = useAuthStore(state => state.accessToken)

    return accessToken ? <Outlet /> : <Navigate to={ROUTE_LOGIN} />
}
